export default {
  apiUrl: process.env.API_URL || '',
  seedUrl: process.env.SEED_URL || ''
};
